import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Footer = () => {
    return (
        <footer className="footer bg-white">
            <div className="footer-inner container">
                <p className="footer-text">
                    To publish a job on <span className="footer-highlight">career.mv</span>, post it on Jobsicle first:
                    visit{" "}
                    <a
                        href="https://www.jobsicle.mv"
                        target="_blank"
                        rel="noreferrer"
                    >
                        www.jobsicle.mv
                    </a>
                    , sign up as an employer, and publish your vacancy — it will be automatically listed on
                    {" "}
                    <span className="footer-highlight">career.mv</span>.
                </p>
                <p className="footer-text mt-3 font-bold">
                    © Career Network by Jobsicle
                </p>
            </div>
        </footer>
    );
};

export default Footer;
